import { Component, OnInit } from '@angular/core';
import { SanctionService } from 'src/app/_services/RH-service/sanction/sanction.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifService } from 'src/app/_services/notif.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { DatePipe } from '@angular/common';



@Component({
  selector: 'app-sancton-update',
  templateUrl: './sancton-update.component.html',
  styleUrls: ['./sancton-update.component.scss']
})
export class SanctonUpdateComponent implements OnInit {

  SanctionForm: FormGroup;
  typeSanctions: any;
  sanctions: any;
  isLoading = false;
  isError = false;
  isSuccess = false;
  isSubmitted = false;
  logo: File = null;
  user;
  users;

  constructor(
    private SanctionService: SanctionService,
    private notifService: NotifService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,

  ) { }

  ngOnInit() {
    this.user = this.authService.getUser();
    this.getTypeSanction();
    this.initForm();
    this.getUsers();
    const sanction_id = +this.route.snapshot.paramMap.get("id");
    this.SanctionService.find(sanction_id).then(
      data => {
        this.sanctions = data;
        this.initForm(true);
      }
    ).catch(
      error => {
        this.translate.get('Sanctions.' + error.error.code)
          .subscribe(val => this.notifService.danger(val));
        this.router.navigate(['/sanction/all'])

      }
    )
  }

  //initialisation du formulaire
  initForm(withsanction = false) {
    if (withsanction) {
      this.SanctionForm = this.formBuilder.group(
        {
          user_id: [this.sanctions.user_id, [Validators.required]],
          sanction_type_id: [this.sanctions.sanction_type_id, [Validators.required]],
          reason_penalty: [this.sanctions.reason_penalty, [Validators.required]],
          start_date: [this.sanctions.start_date, [Validators.required]],
          end_date: [this.sanctions.end_date, [Validators.required]],
        }
      );
    }
    else {
      this.SanctionForm = this.formBuilder.group(
        {
          user_id: ['', [Validators.required]],
          sanction_type_id: ['', [Validators.required]],
          reason_penalty: ['', [Validators.required]],
          start_date: ['', [Validators.required]],
          end_date: ['', [Validators.required]]
        }
      );
    }

  }

  getTypeSanction() {
    this.SanctionService.getTypeSanction().then((res) => {
      this.typeSanctions = res;
      console.log(res)
    }, (error) => {
      this.notifService.danger(error.error.message)

    });
  }
  getUsers() {
    this.SanctionService.getUser().then((res) => {
      this.users = res;
      console.log(res)
    }, (error) => {
      this.notifService.danger(error.error.message)

    });
  }

  get form() {
    return this.SanctionForm.controls;
  }

  onSubmit() {
    console.log('on submit');
    this.isSubmitted = true;
    this.isError = false;
    this.isSuccess = false;
    this.isLoading = false;
    console.log('on submitdddd');

    let pipe = new DatePipe('en-US');
    let date = new Date();
    let currentDate = pipe.transform(date, 'yyyy-MM-dd');

    if (this.SanctionForm.invalid) {
      this.translate.get('Sanction.SubmitError')
        .subscribe(val => this.notifService.danger(val));
      return;
    }
    console.log('on submit');

    this.isLoading = true;
    const formData = new FormData();
    formData.append('user_id', '' + this.form.user_id.value);
    formData.append('sanction_type_id', '' + this.form.sanction_type_id.value);
    formData.append('reason_penalty', '' + this.form.reason_penalty.value);
    if (currentDate > this.form.start_date.value) {
      this.translate.get('Form.StartDateError')
        .subscribe(val => this.notifService.danger(val));
      this.isLoading = false;
      return;
    } else {
      formData.append('start_date', '' + this.form.start_date.value);
    }

    if (this.form.start_date.value > this.form.end_date.value) {
      this.translate.get('Form.EndDateError')
        .subscribe(val => this.notifService.danger(val));
      this.isLoading = false;
      return;
    } else {
      formData.append('end_date', '' + this.form.end_date.value);
    }


    console.log(formData);
    this.SanctionService.update(formData, this.sanctions.id)
      .then(resp => {
        this.translate.get('Sanction.SubmitSuccess')
          .subscribe(val => this.notifService.success(val));
        this.isSubmitted = false;
        this.SanctionForm.reset();
        this.router.navigate(['/sanction/all'])
      })
      .catch(err => {
        console.log(err)
        this.translate.get('Sanction.SubmitErrorSanction')
          .subscribe(val => this.notifService.danger(val));
      })
      .finally(() => this.isLoading = false);
  }

}
